import React from "react";
import PropTypes from "prop-types";

import { Label } from "semantic-ui-react";

export function ConditionName({
  type,
  name,
  datePart,
  workflowPart,
  formFieldName,
}) {
  const getConditionName = () => {
    const formPrefix = () => {
      return `${name.split("Field")[0].trim()}${
        formFieldName ? `: ${formFieldName.trim()}` : ""
      }`;
    };

    switch (type) {
      case "This Workflow":
        return `This Workflow ${
          workflowPart === "Start Date"
            ? `Start ${datePart || "Date"}`
            : workflowPart
        }`;
      case "Form Field":
        return `${formPrefix()}${datePart ? ` ${datePart}` : ""}`;
      default:
        return type;
    }
  };

  return (
    <Label
      data-test="condition-name"
      style={{
        background: "#757575",
        color: "#FFFFFF",
        padding: "0.3em 0.4em",
        margin: "0 0.5em 0.2em 0",
      }}
    >
      {getConditionName()}
    </Label>
  );
}

ConditionName.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  datePart: PropTypes.string,
  workflowPart: PropTypes.string,
  formFieldName: PropTypes.string,
};

ConditionName.defaultProps = {
  formFieldName: null,
  datePart: null,
  workflowPart: null,
};

export default ConditionName;
